module.exports = __webpack_public_path__ + "static/media/thumbs-up.30eaad81.svg";